export const availableRefundTypes = {
  adjustmentRefund: 'adjustment_refund',
  refund: 'refund',
}
